export default __webpack_public_path__ + "static/Domovea_03-31def798a33a73643caddb49958fff46.webp";